import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';

import { captureActionsCenterToken } from '@/helpers/actionsCenterConversion';

const Home = () => import('@/views/Home.vue');
const Help = () => import('@/views/Help.vue');
const Brand = () => import('@/views/Brand.vue');
const Store = () => import('@/views/Store.vue');
const Cart = () => import('@/views/Cart.vue');
const Orders = () => import('@/views/Orders.vue');
const Order = () => import('@/views/Order.vue');
const WdOrder = () => import('@/views/WdOrder.vue');
const GroupOrder = () => import('@/views/GroupOrder.vue');
const Reset = () => import('@/views/Reset.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/reset',
    name: 'Reset',
    component: Reset,
  },
  {
    path: '/:brandId',
    name: 'Brand',
    component: Brand,
  },
  {
    path: '/:brandId/help',
    name: 'Help',
    component: Help,
  },
  {
    path: '/:brandId/orders',
    name: 'Orders',
    component: Orders,
  },
  {
    path: '/:brandId/:storeId',
    name: 'Store',
    component: Store,
  },
  {
    path: '/:brandId/order/:orderId',
    name: 'Order',
    component: Order,
  },
  {
    path: '/:brandId/:storeId/:cartId',
    name: 'Cart',
    component: Cart,
  },
  {
    path: '/:brandId/:storeId/wd-order/:cartId',
    name: 'WdOrder',
    component: WdOrder,
  },
  {
    path: '/:brandId/group-order/:orderId',
    name: 'GroupOrder',
    component: GroupOrder,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  captureActionsCenterToken(to);

  if (to.query.p) {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
      Cookies.set('p', window.btoa(to.query.p));
    } else {
      Cookies.set('p', window.btoa(to.query.p), { domain: '.ocard.co' });
    }
  }

  if (to.query.utm_source) {
    const oneHour = new Date(new Date().getTime() + 60 * 60 * 1000);
    Cookies.set('platform', to.query.utm_source, { expires: oneHour });
  }

  if (to.params.brandId && to.query.autocode) {
    const thirtMinutes = new Date(new Date().getTime() + 30 * 60 * 1000);

    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
      Cookies.set(`_order_autocode_${to.params.brandId}`, to.query.autocode, { expires: thirtMinutes });
    } else {
      Cookies.set(`_order_autocode_${to.params.brandId}`, to.query.autocode, { domain: '.ocard.co', expires: thirtMinutes });
    }
  }

  if (to.query.s) {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
      Cookies.set('s', to.query.s);
    } else {
      Cookies.set('s', to.query.s, { domain: '.ocard.co' });
    }
    const newTo = to;
    delete newTo.query.s;
    next(newTo);
  }
  next();
});

export default router;
